import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";

export class PaymentMethod {
    name: string;
    id: string;
    active: boolean;
}
export class GetInstancePaymentMethodsResponse {
    payment_methods: PaymentMethod[] = [];
}

export function getInstancePaymentMethods(instance_id: number): Promise<AxiosResponse<GetInstancePaymentMethodsResponse>>{
    const path = `/instance/${instance_id}/payment-methods`;
    return Cirus.get(path);
}